import React, { useEffect, useState } from 'react'
import styles from '../../styles/casestudy.module.css'
import Image from 'next/image'
import TestimonialSection from '../common/TestimonialSection'
import { testimonialData, videoTestimonial } from '@/constants/common'
import content from '../../language/ENGLISH.json'
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner'
import VerificationPopup from '../modals/VerificationPopup'
import TrustFactor from '../common/TrustFactor'
import FrequentQuestions from '../homePage/FrequentQuestions'
import { useRouter } from 'next/router'
import MobileTestimonialSection from '../common/MobileTestimonialSection'
import FAQ_mobile from '../Industry/FAQ_mobile'
import MobilePDBanner from '../common/MobilePDBanner'

const Heineken = () => {
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const engagementSnap = [
        {
            title: <>Piloted <b>2 breweries</b><br /> within <b>3 weeks</b>.</>,  
            tag: "Pilot Phase",
            tagColor: "#C9F6FF",
            bgColor: "#EDFBFE",
            width: "44%",
            mobileWidth: "48%"
        },
        {
            title: <>Successfully rolled out to <br /><b>314 breweries</b>.</>,  
            tag: "Rollout Phase",
            tagColor: "#F8D378",
            bgColor: "#FFF6E4",
            width: "54%",
            mobileWidth: "49%"
        },
        {
            title: <><b>2 </b>Integrations </>,
            tag: "Integrations",
            tagColor: "#87F1D5",
            bgColor: "#EDFEF9",
            width: "54%",
            mobileWidth: "48%"
        },
        {
            title: <>Flawless inventory management in all <b>314 breweries</b>.</>,   
            tag: "Outcome",
            tagColor: "#EEC9FF",
            bgColor: "#FCF7FF",
            width: "44%",
            mobileWidth: "49%"
        }
    ]

    const qbPOS = [
        {
            title: "RealTime Insights",
            description: "Real-time visibility and insights for better decision-making.",
            icon: "/assets/caseStudy/hul/realtime-insights.svg"
        },
        {
            title: "Robust Software",
            description: "A powerful, flexible solution tailored for complex supply chains.",
            icon: "/assets/caseStudy/hul/robust-software.svg"
        },
        {
            title: "Seamless integration",
            description: "Smaff integration with your current systems to ensure operations are done without hitches.",
            icon: "/assets/caseStudy/hul/integration.svg"
        },
        {
            title: "Exceptional Support",
            description: "A dedicated customer support team to ensure operations are done seamlessly.",
            icon: "/assets/caseStudy/hul/support.svg"
        },
    ]
    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster help businesses manage inventory efficiently?
                </span>
            ),
            des: "QueueBuster's real-time, automated inventory management and tracking software gives updates to the levels instantly at any given time. The software allows you to fix reorder points, manage more than one location of your warehouse, and generate full reports on the movement of the stock. QueueBuster will, in addition, avoid situations of stockouts and overstock that are a result of less or more stock due to manual data entry and other human errors. This will increase operation efficiency and decrease the cost.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                     Can QueueBuster be integrated with existing ERP systems?
                </span>
            ),
            des: "This solution is quite flexible by design and, therefore, compatible with most ERP API’s on the market. This coupling enables business synchronization of data across platforms whereby information on sales, stock, and customer data remains consistent and updated across the board. That unified approach helps streamline operations, reduce data redundancy, and help furnish comprehensive insights into business performance",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What kind of businesses would benefit from using QueueBuster POS?
                </span>
            ),
            des: "The other advantage of QueBuster POS is its versatility and adaptiveness, which would make it suitable for any kind of business operation. It is suitable for retail stores as inventory management, restaurants as table management, and appointment scheduling for service providers. This surely will be a versatile application supporting businesses of any volume and type, exclusively after embracing it.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster improve the customer experience in retail environments?
                </span>
            ),
            des: "QB ensures customers do better at checkout, thus reducing the time spent at checkouts and ensuring that transactions are right the very first time. The system is versatile and allows several modes of payment, including Visa/Mastercard debit or credit cards, and mobile payment, among others. It is safe and convenient for customers, and QueueBuster's CRM capabilities ensure that businesses understand and leverage customer preferences in personalized interactions and targeted promotions whereby customers are found to be happier with the services and more loyal.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is QueueBuster good for multichain businesses?
                </span>
            ),
            des: "This futuristic POS software was built for multilocation business setups. It supports centralized control, meaning business owners and managers can easily monitor and control operations at various locations directly from a single dashboard. It makes doing business easier, ensuring consistency in terms of pricing, inventory management, and sales reporting for businesses to operate in mirrored synchronization and at the same level as other branches. It enables easy management of staff and resource allocation in the different branches.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What kind of reporting capabilities does QueueBuster provide?
                </span>
            ),
            des: "QueueBuster provides better levels of reporting, nurturing every source of business operations. Some of the easy-to-compile reports from the system include sales, present stock levels, employee performance, and even customer behavior. Fully customizable, businesses can zone in on specific metrics that matter most for their business. QueueBuster will enable informed business changes, discovery of trends, and strategies towards developing effective plans for improving profitability.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How is data safety and compliance achieved by QueueBuster?
                </span>
            ),
            des: "A high level of data security and compliance is one of the strong points of QueueBuster, with protocols for strict encryption in transit and in storage. Close monitoring of this is done through regular security audits. Various industry standards and compliance regulations, such as PCI DSS for payment processing, are inducing the system to protect sensitive information. Incumbent functionalities offered by QueueBuster further include user access controls and activity logs, which will enable a business to monitor and manage a lot of people having access to the critical data for accountability.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                     Can QueueBuster support mobile and remote business operations?
                </span>
            ),
            des: "QB is enabled for mobile and remote running of business activities and operations; hence, useful to run the business on the go or with teams that are dislocated. The system can be accessed through a mobile interface that enables users to manage sales, inventory, and customer interactions from anywhere. This way, the business remains operable at all times, therefore giving the owner great flexibility and the same to his or her customers.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How easy is it to train your staff on the QueuBuster POS?
                </span>
            ),
            des: "Our software has been developed to be very user-friendly, with easily navigable interfaces that anyone can master in almost no time. It has been styled with contextual guides for step-by-step tutorials and training resources to allow new users to easily get over the learning curve. Besides, QueueBuster comes with customer support and training for everybody to ensure comfort and proficiency among the staff using it. This cuts down the lag time and starts the advantage to the business practically immediately after using QueueBuster.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What type of customer support is available for QueueBuster?
                </span>
            ),
            des: "QueueBuster has deep customer support in each manner in which a business may want to use the solution. Some of its support options include phone and email support, live chat, and a resourceful knowledge base full of FAQs, guides, and how-to information. On top of that, the solution provides onboard support and training that is personalized to the user to help them set up and leverage a POS system to the best extent. All this dedication to supporting its customers ensures that companies get the resources and help they need to overcome any hurdles toward their own operational goals.",
            id: 10,
            activeIndex: 0,
        },
    ]
    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                {
                    mobileView ?
                        <div className={styles.mobile_hero_img} style={{ backgroundImage: "url('/assets/caseStudy/heineken/mobileHeineken.webp')" }}>
                            <div>
                                <h1>How <span className={styles.blue_text}>314 Heineken</span> Breweries in Nigeria Accelerated Growth</h1>
                                <div className={styles.hero_content}>
                                    <div>
                                        <p>314+</p>
                                        <p>Locations Scalability</p>
                                    </div>
                                    <div>
                                        <p>85%</p>
                                        <p>Stock Monitoring Enhancement</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                    <div className={styles.hero_section_inner_container}>
                            <div className={styles.hero_section_image}><Image src="/assets/caseStudy/heineken/mobile-hero-img.webp" alt="heineken hero image" fill /></div>
                            <div className={styles.hero_heading1}><h1>Know how 314 Heineken breweries in Nigeria gained automated business momentum!</h1></div>
                            <div className={styles.hero_content} style={{justifyContent:"space-between"}}>
                                <div>
                                    <p>314+</p>
                                    <p>Locations Scalability</p>
                                </div>
                                <div>
                                    <p>85%</p>
                                    <p>Stock Monitoring Enhancement</p>
                                </div>
                                <div>
                                    <p>100%</p>
                                    <p>Error-Free Transactions </p>
                                </div>
                            </div>
                        </div>

                }
                <div className={styles.light_blue_box}>
                    <div>
                        <p>About Heineken</p>
                        <p>Heineken is a well-established Dutch Multinational brewing company, founded in 1864 in Amsterdam. The Heineken Group operates across more than 70 countries globally, employing over 55,000 people and over 165 breweries worldwide. Heineken produces various brands of beer and cider, enjoyed globally by millions.</p>
                    </div>
                    <div>
                        <p>Deployed Solution</p>
                        <p>QueueBuster was selected as the best solution to achieve Heineken's requirements. Within 314 Heineken-owned breweries in Nigeria, the system was implemented and changed how these breweries handled their billing and inventory management processes. Heineken would now be able to automate all such operations with QueueBuster, making all its outlets seamless in operation completely accurate in their sales, and properly inventoried.</p>
                    </div>
                </div>
                <div className={styles.owner_words}>
                    <p>“We did try over 6 Android-based POS solutions before we stumbled on QueueBuster. We had been pleasantly surprised to find that QB is the most complete POS app in existence today with ERP-level features. We have recommended that QueueBuster be deployed across the entire African continent.”</p>
                    <p className={styles.name}>Mr. Chima</p>
                    <p className={styles.position}>Innovation & Digital Product Development Manager</p>
                </div>
            </div >
            <div className={styles.section_two}>
                <div>
                    <div className={styles.problem_statement}>
                        <p className={styles.orange_heading}>Problem Statement</p>
                        <p>Heineken had a huge challenge in Nigeria, and Africa, whereby there was a need to introduce automation to over 300 breweries. This huge network was impractical to handle manually day-to-day billing and inventory operations. In need of efficiency, Heineken wanted a powerful Android-based POS system to handle such a highly complex and large network.</p>
                        <p className={styles.green_heading}>Outcomes</p>
                        <p>Heineken Nigeria has been improved immensely in the following ways with QueueBuster POS implementation:
                        </p>
                        <ul>
                            <li><b>Efficiency:</b> Automating the billing and inventory processes reduced manual workload and minimized errors.</li>
                            <li><b>Real-Time Tracking:</b> Heineken can, in real-time, monitor sales and manage inventory across the whole network of breweries.</li>
                            <li><b>Streamlined Operations:</b> The manual workflow of these processes transformed into an efficient, automated workflow driving overall operational efficiency.</li>
                        </ul>
                    </div>
                    <div className={styles.blue_box}>
                        <div className={styles.client_img}><Image src="/assets/caseStudy/heineken/heineken.svg" alt="heineken" fill /></div>
                        <div className={styles.row}>                    
                            <p className={styles.light_heading}>Industry Type</p>
                            <p>Food & Beverages</p>
                        </div>
                        <div className={styles.row} style={{ display: "flex", gap: "3rem" }}>
                            <div>
                                {/* <p className={styles.light_heading}>Type of Business</p> */}
                                {/* <p>Products</p> */}
                            </div>
                            <div>
                                {/* <p className={styles.light_heading}> Beverage</p> */}
                                {/* <p>300+</p> */}
                            </div>
                        </div>
                        <div className={styles.row}>
                            <p className={styles.block}>Inventory Management</p>
                            <p className={styles.block}>CRM & Loyalty</p>
                            <p className={styles.block}>Digital Payments</p>
                            <p className={styles.block}>Cloud Dashboard</p>
                            <p className={styles.block}>Billing/Invoices</p>
                        </div>
                    </div>
                </div>
                <div>
                    <p className={styles.pink_heading}>Engagement Snapshot</p>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                        {
                            engagementSnap?.map((ele) => {
                                return (
                                    <div style={{ backgroundColor: ele?.bgColor, width: mobileView ? ele?.mobileWidth : ele?.width, padding: mobileView ? "1.5rem" : "3.75rem", borderRadius: "1rem" }}>
                                        <p style={{ font: mobileView ? "normal normal normal 1.8rem/3rem Inter" : "normal normal normal 2.4rem/3rem Inter" }}>{ele?.title}</p>
                                        <div style={{ backgroundColor: ele?.tagColor, padding: "1rem 2rem", borderRadius: "70px", width: "fit-content", marginTop: "2rem" }}>{ele?.tag}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={styles.qb_POS}>
                <h3>Why Choose QueueBuster POS?</h3>
                <div className={styles.qb_POS_container}>
                    {
                        qbPOS?.map((ele) => {
                            return (
                                <div>
                                    <div style={{ height: "5rem", width: "5rem", position: "relative", margin: "2rem auto" }}><Image src={ele?.icon} alt={ele?.title} fill /></div>
                                    <p style={{ font: "normal normal 500 1.8rem/2.6rem Inter", textAlign: "center" }}>{ele?.title}</p>
                                    <p style={{ font: "normal normal normal 1.4rem/2rem Inter", textAlign: "center", color: "#6F7F96" }}>{ele?.description}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className={styles.supply_chain}>
                <div>
                    <h4>Transform Your Supply Chain with QueueBuster POS</h4>
                    <p>QueueBuster POS is dedicated to providing innovative solutions that streamline operations, and enhance visibility across the supply chain, and with our powerful software, businesses like HUL can maintain better planning, forecasting, and overall efficiency.</p>
                </div>
                <div style={{ height: mobileView ? "15rem" : "20rem", width: mobileView ? "27rem" : "35rem", position: "relative" }}><Image src="/assets/caseStudy/hul/supply_chain.webp" alt="upply Chain with QueueBuster POS" fill /></div>
            </div>

            <div className={styles.other_components}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>
            <div style={{ margin: mobileView ? "0 3rem" : "0 5rem" }}><TrustFactor /></div>
            <div>{
                mobileView ?
                    <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"Frequently Asked Questions"} />
                    :
                    <FrequentQuestions FaqTableData={faqs} heading={"Frequently Asked Questions"} />
            }</div>
            <div className={styles.other_components}>{
                mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            }</div>
        </>
    )
}

export default Heineken